import axios from 'axios';

export const getApiBaseUrl = () =>
    (typeof window !== 'undefined' && window.REACT_APP_API_URL) ||
    process.env.REACT_APP_API_URL ||
    'http://localhost:8080';

const axiosInstance = axios.create({
    baseURL: getApiBaseUrl(),
    withCredentials: true,
});

let isRefreshing = false;
let failedQueue: any[] = [];

const processQueue = (error: any) => {
    failedQueue.forEach(prom => error ? prom.reject(error) : prom.resolve());
    failedQueue = [];
};

axiosInstance.interceptors.response.use(
    response => response,
    async error => {
        const originalRequest = error.config;

        // If the user is not logged in, reject the request
        if (!localStorage.getItem('user')) {
            return Promise.reject(error);
        }

        if (error?.response?.status === 401 && !originalRequest._retry && !originalRequest.url.includes('/auth/refresh')) {
            if (isRefreshing) {
                return new Promise((resolve, reject) => {
                    failedQueue.push({ resolve, reject });
                }).then(() => axiosInstance(originalRequest));
            }

            originalRequest._retry = true;
            isRefreshing = true;

            try {
                await axiosInstance.post('/auth/refresh');
                processQueue(null);
                isRefreshing = false;
                return axiosInstance(originalRequest);
            } catch (refreshError) {
                processQueue(refreshError);
                isRefreshing = false;
                localStorage.removeItem('user');
                return Promise.reject(refreshError);
            }
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;
